import React from "react"

import Title from "../Title"
import TechnologyIcons from "./technologyIcons"
import { Wrapper, IconsContainer } from "./Technology.styled"
function Technology() {
  return (
    <Wrapper>
      <Title title="Technology" />
      <IconsContainer numberOfIcons={TechnologyIcons.length}>
        <div>
          {TechnologyIcons.map(icon => (
            <span key={icon.name} color={icon.color}>
              {icon.icons}
            </span>
          ))}
        </div>
        <div>
          {TechnologyIcons.map(icon => (
            <span key={icon.name} color={icon.color}>
              {icon.icons}
            </span>
          ))}
        </div>
      </IconsContainer>
    </Wrapper>
  )
}

export default Technology
